import clsx from 'clsx'

import { Switch } from 'shared/ui/switch'

import s from './styles.module.scss'

interface Props {
  isChecked: boolean
  setIsChecked: (isChecked: boolean) => void
  title: string
}
export const SwitchBlock = ({ isChecked, setIsChecked, title }: Props) => {
  return (
    <div className={clsx(s.switchBlock, s.itemBlock)}>
      <span className={clsx(s.text, 'medium-16')}>{title}</span>

      <Switch
        isChecked={isChecked}
        onChange={(value) => setIsChecked(!value)}
      />
    </div>
  )
}
